function Filter() {
  return function(amount, currencySymbol) {

    if (!amount) {
      return `${currencySymbol}0`;
    }

    amount = parseFloat(amount);

    if (amount % 1 === 0) {
      amount = amount.toFixed(0);
    } else {
      amount = amount.toFixed(2);
    }

    return currencySymbol + amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); //eslint-disable-line
  };
}

Filter.$inject = [];

export default Filter;



// WEBPACK FOOTER //
// ./src/filters/tlCurrencyFilter.js